// extracted by mini-css-extract-plugin
export default {"legend":"GenderSplitSlider_legend__f9+ie"};